import { createRouter, createWebHashHistory } from "vue-router";
// import { getCurrentUser } from '@/firebase'

/// pages from theme
import Default from "../views/dashboards/Default.vue";

import Settings from "../views/pages/account/Settings.vue";
import Basic from "../views/auth/signin/Basic.vue";
// import Sales from "../views/dashboards/Sales.vue";
// import Overview from "../views/pages/profile/Overview.vue";
// import Projects from "../views/pages/profile/Projects.vue";
// import Timeline from "../views/pages/projects/Timeline.vue";
// import Pricing from "../views/pages/Pricing.vue";
// import RTL from "../views/pages/Rtl.vue";
// import Charts from "../views/pages/Charts.vue";
// import Notifications from "../views/pages/Notifications.vue";
// import Kanban from "../views/applications/Kanban.vue";
// import Wizard from "../views/applications/wizard/Wizard.vue";
// import DataTables from "../views/applications/DataTables.vue";
// import Calendar from "../views/applications/Calendar.vue";
// import NewProduct from "../views/ecommerce/products/NewProduct.vue";
// import EditProduct from "../views/ecommerce/products/EditProduct.vue";
// import ProductPage from "../views/ecommerce/products/ProductPage.vue";
// import OrderDetails from "../views/ecommerce/orders/OrderDetails";
// import OrderList from "../views/ecommerce/orders/OrderList";
// import NewUser from "../views/pages/users/NewUser.vue";
// import Settings from "../views/pages/account/Settings.vue";
// import Billing from "../views/pages/account/Billing.vue";
// import Invoice from "../views/pages/account/Invoice.vue";
// import Widgets from "../views/pages/Widgets.vue";
// import Basic from "../views/auth/signin/Basic.vue";
// import Cover from "../views/auth/signin/Cover.vue";
// import Illustration from "../views/auth/signin/Illustration.vue";
// import ResetCover from "../views/auth/reset/Cover.vue";
// import SignupCover from "../views/auth/signup/Cover.vue";

/// project pages
/// master
import Mbank from "../views/master/banks.vue";
import Mwarn from "../views/master/warning.vue";
import Millegal from "../views/master/illegalUnits.vue";
// import Mgroup from "../views/master/assetGroup.vue";
import Masset from "../views/master/assetType.vue";
import Mprefix from "../views/master/prefixs.vue";
import Maddress from "../views/master/address.vue";
import Mgrade from "../views/master/customerGrade.vue";
// import Mdoc from "../views/master/docType.vue";
// import Munit from "../views/master/units.vue";
import Mpawn from "../views/master/bankPawn.vue";
import Mcash from "../views/master/cashAccount.vue";
import Mtransaction from "../views/master/transactionType.vue";
// import Mbanknote from "../views/master/bankNote.vue";
// import Mbiz from "../views/master/businessType.vue";

/// generals
import Gdash from "../views/generals/dashboards.vue";
import Gjor6 from "../views/generals/j6.vue";

import Goverhis from "../views/generals/unitOverdueHistory.vue";
import Ghistory from "../views/generals/history.vue";
import Gkeeptk from "../views/generals/keepTickets.vue";
// import Gsplitasset from "../views/generals/splitAssets.vue";
// import Ghistory from "../views/generals/history.vue";
// import Gticketchain from '../views/generals/ticketChain.vue';
// import Gover from "../views/generals/unitOverdue.vue";
import Gdeferitems from "../views/generals/deferItems.vue";
import Gseize from "../views/generals/seize.vue";
import GhistoryG from "../views/generals/historyGroup.vue";
import Gmovement from "../views/generals/movement.vue";
import GtimeAllow from "../views/generals/timeAllow.vue";


/// finances
import Foverall from "../views/finances/overall.vue";
// import Ffinance from "../views/finances/finance.vue";
import Fcash from "../views/finances/cashMovement.vue";
import Fmoney from "../views/finances/moneyManage.vue";
import Fdrawer from "../views/finances/cashDrawer.vue";
import Fbkdrawer from "../views/finances/bankDrawer.vue";
import Freconcile from "../views/finances/reconcile.vue";
import Fqrbillpayment from "../views/finances/qrBillPayment.vue";

/// customers
import CustomerInsight from "../views/customers/CustomerInsight.vue";
import NewCustomerHistory from "../views/customers/NewCustomerHistory.vue";
// import Gdeposit from "../views/customers/deposit.vue";
// import Gcustomerinfo from "../views/customers/customerInfo.vue";
// import Gcustomerport from '../views/customers/portfolio.vue';

/// stocks
import STlocation from "../views/stocks/locations.vue";
import STstock from "../views/stocks/stock.vue";

/// Reports
// import RPall from "../views/reports/reportAll.vue";
// import RPday from "../views/reports/reportDay.vue";
// import RPpawn from "../views/reports/reportPawn.vue";
import RPprofit from "../views/reports/reportProfit.vue";
// import RPaddcap from "../views/reports/reportAddCap.vue";
// import RPreducecap from "../views/reports/reportReduceCap.vue";
// import RPredeem from "../views/reports/reportRedeem.vue";
// import RPcancel from "../views/reports/reportCancel.vue";
import RPdefer from "../views/reports/reportDefer.vue";
// import RPtop20 from "../views/reports/reportTop20.vue";
// import RPtransaction from "../views/reports/reportTransactions.vue";
import EPoverdueitems from "../views/reports/reportOverdueItems.vue";
import RpAuditsampling from "../views/reports/reportAuditSampling.vue";
import RpSmsNotification from "../views/reports/reportSmsNotification.vue";
import RpJor7 from "../views/reports/reportJ7.vue";

/// credit score 
import CsUpload from "../views/credit-score/CsUpload.vue";
import CsDashboard from "../views/credit-score/CsDashboard.vue";
import CsTop100 from "../views/credit-score/CsTop100.vue";
import CsForecast from "../views/credit-score/CsForecast.vue";
import CsPortfolio from "../views/credit-score/CsPortfolio.vue";
import CsCustomerDetail from "../views/credit-score/CsCustomerDetail.vue";

/// settings
import Sopen from "../views/settings/openBranch.vue";
import Spre from "../views/settings/prePrint.vue";
import Sinterest from "../views/settings/interest.vue";
// import Sstock from "../views/settings/stock.vue";
// import Sprice from "../views/settings/goldPrice.vue";
import Mholiday from "../views/settings/holidays.vue";
// import Srole from "../views/settings/securityRole.vue";
// import Ssetup from "../views/settings/securitySetup.vue";
// import Suser from "../views/settings/users.vue";
import Ssetbranch from "../views/settings/updateBranch.vue";

/// users
import Umanage from "../views/users/UserManagement.vue";
import Urole from "../views/users/UserRoleManagement.vue";
import Uschedule from "../views/users/UserSchedule.vue";

/// support
import Supdate from "../views/support/updateData.vue";
import SworkItemHistory from "../views/support/workItemHistory.vue";
import SdeleteLineRegis from "../views/support/deleteLineRegistration.vue";



const routes = [
  // main redirect page
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  // old redirect page
  {
    path: "/dashboards/dashboard-default",
    name: "Default",
    component: Default,
    meta: {
      requiresAuth: true,
    },
  },
  // auth redirect page
  {
    path: "/generals/dashboard",
    name: "Dashboard",
    component: Gdash,
    meta: {
      requiresAuth: true,
    },
  },
  // generals
  {
    path: "/generals/deposit-withdraw_tk",
    name: "Deposit-Withdraw Ticket",
    component: Gkeeptk,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/history",
    name: "History",
    component: Ghistory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/movement",
    name: "Movement",
    component: Gmovement,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/jor_six",
    name: "Jor6",
    component: Gjor6,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/generals/unit_overdue_history",
    name: "UnitOverdueHistory",
    component: Goverhis,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/generals/split_assets",
  //   name: "SplitAssets",
  //   component: Gsplitasset,
  // },
  // {
  //   path: "/generals/ticket_chain",
  //   name: "TicketChain",
  //   component: Gticketchain,
  // },
  // {
  //   path: "/generals/unit_overdue",
  //   name: "UnitOverdue",
  //   component: Gover,
  // },
  {
    path: "/generals/defer_items",
    name: "DeferItems",
    component: Gdeferitems,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/seize",
    name: "Seize",
    component: Gseize,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/history_group",
    name: "HistoryGroup",
    component: GhistoryG,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/generals/time_allow",
    name: "TimeAllow",
    component: GtimeAllow,
    meta: {
      requiresAuth: true,
    },
  },

  // finances
  {
    path: "/finances/ticket",
    name: "TransactionOverall",
    component: Foverall,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/finances/finance",
  //   name: "Finance",
  //   component: Ffinance,
  // },
  {
    path: "/finances/cash_movement",
    name: "CashMovement",
    component: Fcash,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finances/transactions_management",
    name: "TranctionsManagement",
    component: Fmoney,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finances/cash_drawer",
    name: "CashDrawer",
    component: Fdrawer,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finances/bank_drawer",
    name: "BankDrawer",
    component: Fbkdrawer,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finances/reconcile",
    name: "Reconcile",
    component: Freconcile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/finances/qr_bill_payment",
    name: "QRBillPayment",
    component: Fqrbillpayment,
    meta: {
      requiresAuth: true,
    },
  },
  // customers
  {
    path: "/customers/insight",
    name: "CustomerInsight",
    component: CustomerInsight,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/new_customer_history",
    name: "NewCustomerHistory",
    component: NewCustomerHistory,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/customers/customer_deposit",
  //   name: "CustomerDeposit",
  //   component: Gdeposit,
  // },
  // {
  //   path: "/customers/customer_info",
  //   name: "CustomerInfo",
  //   component: Gcustomerinfo,
  // },
  // {
  //   path: "/customers/customer_port",
  //   name: "CustomerPort",
  //   component: Gcustomerport,
  // },
  // stock
  {
    path: "/stocks/location",
    name: "Location",
    component: STlocation,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/stocks/stock",
    name: "Stock",
    component: STstock,
    meta: {
      requiresAuth: true,
    },
  },
  // reports
  // {
  //   path: "/reports/report_all",
  //   name: "ReportAll",
  //   component: RPall,
  // },
  // {
  //   path: "/reports/report_day",
  //   name: "ReportDay",
  //   component: RPday,
  // },
  // {
  //   path: "/reports/report_pawn",
  //   name: "ReportPawn",
  //   component: RPpawn,
  // },
  {
    path: "/reports/report_profit",
    name: "ReportpProfit",
    component: RPprofit,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/reports/report_addcap",
  //   name: "ReportAddCap",
  //   component: RPaddcap,
  // },
  // {
  //   path: "/reports/report_reducecap",
  //   name: "ReportReduceCap",
  //   component: RPreducecap,
  // },
  // {
  //   path: "/reports/report_redeem",
  //   name: "ReportRedeem",
  //   component: RPredeem,
  // },
  // {
  //   path: "/reports/report_cancel",
  //   name: "ReportCancel",
  //   component: RPcancel,
  // },
  {
    path: "/reports/report_defer",
    name: "ReportDefer",
    component: RPdefer,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/reports/report_top_20",
  //   name: "ReportTop20",
  //   component: RPtop20,
  // },
  // {
  //   path: "/reports/report_transaction",
  //   name: "ReportTransaction",
  //   component: RPtransaction,
  // },
  {
    path: "/reports/report_overdue_items",
    name: "ReportOverdueItems",
    component: EPoverdueitems,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/report_audit_sampling",
    name: "ReportAuditSampling",
    component: RpAuditsampling,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/report_sms_notification",
    name: "ReportSmsNotification",
    component: RpSmsNotification,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/report_jor7",
    name: "ReportJor7",
    component: RpJor7,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/cs_top100",
    name: "CsTop100",
    component: CsTop100,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/cs_forecast",
    name: "CsForecast",
    component: CsForecast,
    meta: { requiresAuth: true },
  },

  //score

  {
    path: "/credit-score/cs_upload",
    name: "CsUpload",
    component: CsUpload,
    meta: { requiresAuth: true },
  },
  {
    path: "/credit-score/cs_dashboard",
    name: "CsDashboard",
    component: CsDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/credit-score/cs_portfolio",
    name: "CsPortfolio",
    component: CsPortfolio,
    meta: { requiresAuth: true },
  },
  {
    path: "/credit-score/cs_customer_detail",
    name: "CsCustomerDetail",
    component: CsCustomerDetail,
    meta: { requiresAuth: true },
  },

  // support
  {
    path: "/support/update_data",
    name: "UpdateImages",
    component: Supdate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/support/work_item_history",
    name: "WorkItemsHistory",
    component: SworkItemHistory,
    meta: { requiresAuth: true },
  },
  {
    path: "/support/delete_line_registration",
    name: "DeleteLineRegistration",
    component: SdeleteLineRegis,
    meta: { requiresAuth: true },
  },
  // master
  {
    path: "/master/bank",
    name: "Bank",
    component: Mbank,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/master/warning",
    name: "Warning",
    component: Mwarn,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/illegal_assets",
    name: "IllegalAssets",
    component: Millegal,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/master/asset_group",
  //   name: "AssetGroup",
  //   component: Mgroup,
  // },
  {
    path: "/master/asset_type",
    name: "AssetType",
    component: Masset,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/prefix",
    name: "Prefix",
    component: Mprefix,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/address",
    name: "Address",
    component: Maddress,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/customer_grade",
    name: "CustomerGrade",
    component: Mgrade,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/master/document_type",
  //   name: "DocumentType",
  //   component: Mdoc,
  // },
  // {
  //   path: "/master/units",
  //   name: "Units",
  //   component: Munit,
  // },
  {
    path: "/master/pawn_bank",
    name: "PawnBank",
    component: Mpawn,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/cash_account",
    name: "CashAccount",
    component: Mcash,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/master/transaction_type",
    name: "FinancialTransactionType",
    component: Mtransaction,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/master/bank_note",
  //   name: "BankNote",
  //   component: Mbanknote,
  // },
  // {
  //   path: "/master/business_type",
  //   name: "BusinessType",
  //   component: Mbiz,
  // },
  // settings
  {
    path: "/settings/open_branch",
    name: "OpenBranch",
    component: Sopen,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/setting_branch",
    name: "SetBranch",
    component: Ssetbranch,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/pre_print_and_running",
    name: "PrePrint",
    component: Spre,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings/interest",
    name: "Interest",
    component: Sinterest,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/settings/stock",
  //   name: "SetStock",
  //   component: Sstock,
  // },
  // {
  //   path: "/settings/gold_price",
  //   name: "GoldPrice",
  //   component: Sprice,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/settings/holidays",
    name: "Holidays",
    component: Mholiday,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pages/account/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/signin",
    name: "Signin Basic",
    component: Basic,
  },
  // users
  {
    path: "/users/manage",
    name: "UserManagement",
    component: Umanage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/role",
    name: "UserRoleManagement",
    component: Urole,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/schedule",
    name: "UserSchedule",
    component: Uschedule,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async (to) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && localStorage.getItem("FR-SDK-nvtx-admin") === null) {
    return "/signin";
  }
});

export default router;
